import { Link } from "react-router-dom";
import { FileCheck2, Loader2 } from "lucide-react";

export const ProposalPdfProgress = ({ pdfs, leadId }) => {
  const ready = pdfs.exports.filter((item) => item.status === "ready").length;
  const failed = pdfs.exports.filter((item) => item.status === "failed").length;
  if (!ready && !failed && !pdfs.working && !pdfs.error) return null;
  return <div className="flex flex-wrap items-center gap-x-4 gap-y-2 border-y border-border py-3 text-sm" data-testid="proposal-pdf-progress" aria-live="polite">
    <span className="inline-flex items-center gap-2" data-testid="proposal-pdf-progress-summary">
      {pdfs.working ? <Loader2 size={16} className="animate-spin" /> : <FileCheck2 size={16} />}
      {pdfs.working ? `${pdfs.working} proposal PDF${pdfs.working > 1 ? "s" : ""} generating` : `${ready} proposal PDF${ready !== 1 ? "s" : ""} ready`}
    </span>
    {failed > 0 && <span className="text-destructive" data-testid="proposal-pdf-failed-count">{failed} failed — retry from Actions</span>}
    {pdfs.error && <span className="text-destructive" data-testid="proposal-pdf-status-error">{pdfs.error}</span>}
    <Link to={`/app/leads/${leadId}?tab=Documents`} data-testid="proposal-pdf-documents-link" className="text-primary font-semibold underline underline-offset-4">Documents</Link>
  </div>;
};